export var TextContentType;
(function (TextContentType) {
    TextContentType["Text1"] = "Text1";
    TextContentType["Text2"] = "Text2";
    TextContentType["Text3"] = "Text3";
    TextContentType["H1"] = "H1";
    TextContentType["H2"] = "H2";
    TextContentType["H3"] = "H3";
    TextContentType["H4"] = "H4";
})(TextContentType || (TextContentType = {}));
export var TextContentHighlightMod;
(function (TextContentHighlightMod) {
    TextContentHighlightMod["Primary"] = "primary";
    TextContentHighlightMod["Alert"] = "alert";
    TextContentHighlightMod["Centered"] = "centered";
    TextContentHighlightMod["Callout"] = "callout";
})(TextContentHighlightMod || (TextContentHighlightMod = {}));
export var TextContentInteractionScheme;
(function (TextContentInteractionScheme) {
    TextContentInteractionScheme["Telephone"] = "phone";
    TextContentInteractionScheme["Email"] = "email";
    TextContentInteractionScheme["Link"] = "link";
})(TextContentInteractionScheme || (TextContentInteractionScheme = {}));
export var GridItemType;
(function (GridItemType) {
    GridItemType["label"] = "LABEL";
    GridItemType["heading"] = "HEADING";
    GridItemType["empty"] = "EMPTY";
    GridItemType["cell"] = "CELL";
})(GridItemType || (GridItemType = {}));
export var VideoDisplayContext;
(function (VideoDisplayContext) {
    VideoDisplayContext["Modal"] = "modal";
    VideoDisplayContext["Default"] = "default";
})(VideoDisplayContext || (VideoDisplayContext = {}));
